import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section className="about-section">
      <Row className="align-items-center w-100 mx-0">
        {/* Left Side: Text + Button */}
        <Col className="about-content px-5">
          <h2 className="about-title">
            From The Get Go Start Up...
          </h2>
          <p className="about-text">
            VDNI provides a bouquet of services that help from YouTube channel management & designing, audio & video distribution, digital marketing, and brand promotion. 
            Our services consider everything from the audience our clients would love to reach, to the type of content and interactions that will efficiently and effectively capture them irrespective of their geographies.
          </p>
          <Link to="/servicesnew" className="explore-btn">
            Explore Services
          </Link>
        </Col>
      </Row>
    </section>
  );
};

export default AboutUs;
